<form class="flex justify-content-center" (ngSubmit)="onSubmit()" [formGroup]="userInfoForm">
  <div class="flex flex-column">
    <div class="flex">
      <mat-form-field appearance="outline" class="w-auto me-3">
        <mat-label>First Name</mat-label>
        <input matInput type="text" name="userFirstName" id="userFirstName" formControlName="userFirstName" width="200px">
      </mat-form-field>
      <mat-form-field appearance="outline" class="w-auto">
        <mat-label>Last Name</mat-label>
        <input matInput type="text" name="userLastName" id="userLastName" formControlName="userLastName" width="200px">
      </mat-form-field>
    </div>
    <mat-form-field appearance="outline">
      <mat-label>Address</mat-label>
      <input matInput type="text" name="userAddress" id="userAddress" formControlName="userAddress">
    </mat-form-field>
    <mat-form-field appearance="outline">
      <mat-label>City</mat-label>
      <input matInput type="text" name="userCity" id="userCity" formControlName="userCity">
    </mat-form-field>
    <mat-form-field appearance="outline">
      <mat-label>Postal Code</mat-label>
      <input matInput type="text" name="userPostalCode" id="userPostalCode" formControlName="userPostalCode">
    </mat-form-field>
    <mat-form-field appearance="outline">
      <mat-label>State/Province</mat-label>
      <input matInput type="text" name="userStateProvince" id="userStateProvince" formControlName="userStateProvince">
    </mat-form-field>
    <mat-form-field appearance="outline">
      <mat-label>Country</mat-label>
      <input matInput type="text" name="userCountry" id="userCountry" formControlName="userCountry">
    </mat-form-field>
    <mat-form-field appearance="outline">
      <mat-label>Phone</mat-label>
      <input matInput type="tel" name="userPhone" id="userPhone" formControlName="userPhone">
    </mat-form-field>
    <mat-form-field appearance="outline">
      <mat-label>Email</mat-label>
      <input matInput type="email" name="userEmail" id="userEmail" formControlName="userEmail">
    </mat-form-field>

    <div>
      @if (!editInfo) {
        <button mat-raised-button type="button" name="editUserInfo" id="editUserInfo" (click)="editUserInfo()">Edit</button>
      }
      @if (editInfo) {
        <button mat-raised-button type="submit" name="sumbitUserData" id="sumbitUserData">Save</button>
      }
    </div>
  </div>
</form>

<div class="flex flex-column flex-wrap align-content-center mt-5 pb-lg-5">
  <div class="col-10">
    <label class="fw-bold mb-3">Favorites</label>
    <table mat-table [dataSource]="userFavoriteActivities" class="mat-elevation-z8">
      <ng-container matColumnDef="name">
        <th mat-header-cell *matHeaderCellDef> Name </th>
        <td mat-cell *matCellDef="let element"> {{element.name}} </td>
      </ng-container>
      <ng-container matColumnDef="mainActivityType">
        <th mat-header-cell *matHeaderCellDef> Main Activity Type </th>
        <td mat-cell *matCellDef="let element"> {{element.mainActivityType}} </td>
      </ng-container>
      <ng-container matColumnDef="description">
        <th mat-header-cell *matHeaderCellDef> Description </th>
        <td mat-cell *matCellDef="let element"> {{element.description}} </td>
      </ng-container>
      <tr mat-header-row *matHeaderRowDef="userFavoritesColumns"></tr>
      <tr mat-row *matRowDef="let row; columns: userFavoritesColumns;"></tr>
    </table>
  </div>
  <div class="col-10 mt-5">
    <label class="fw-bold mb-3">Booked Activities</label>
    <!-- <span style="visibility: hidden;">{{booked[0].date}}</span> -->
    <table mat-table [dataSource]="dataSource" class="mat-elevation-z8">
      <ng-container matColumnDef="date">
        <th mat-header-cell *matHeaderCellDef> Date </th>
        <td mat-cell *matCellDef="let element"> {{element.date | date:'longDate'}} </td>
      </ng-container>
      <ng-container matColumnDef="slots">
        <th mat-header-cell *matHeaderCellDef> Slots </th>
        <td mat-cell *matCellDef="let element"> {{element.slots}} </td>
      </ng-container>
      <ng-container matColumnDef="pricePerSlot">
        <th mat-header-cell *matHeaderCellDef> Price Per Slot </th>
        <td mat-cell *matCellDef="let element"> {{element.pricePerSlot | currency}} </td>
      </ng-container>
      <ng-container matColumnDef="total">
        <th mat-header-cell *matHeaderCellDef> Total </th>
        <td mat-cell *matCellDef="let element"> {{element.total | currency}} </td>
      </ng-container>
      <ng-container matColumnDef="storeName">
        <th mat-header-cell *matHeaderCellDef> Store Name </th>
        <td mat-cell *matCellDef="let element"> {{element.storeName}} </td>
      </ng-container>
      <ng-container matColumnDef="activityName">
        <th mat-header-cell *matHeaderCellDef> Activity Name </th>
        <td mat-cell *matCellDef="let element"> {{element.activityName}} </td>
      </ng-container>
      <tr mat-header-row *matHeaderRowDef="userBookedColumns"></tr>
      <tr mat-row *matRowDef="let row; columns: userBookedColumns;"></tr>
    </table>
  </div>
</div>
